import React from "react";
import { Formik, Form } from "formik";
import l from "components/util/l";
import ColumnField from "components/collections/forms/ColumnFormView.sub.field.view";

const ColumnFormView = ({
  formRef,
  error,
  isLoading,
  flow = {},
  initialColumns = [],
  collection = {},
  collections = [],
  isUpdate = false,
  onSubmit = () => { },
}) => (
  <div className="card">

    <div className="card-header">
      <h3 class="mb-0">
        { isUpdate ? l("Editar campo%CA034") : l("Crear campo%CA035") }
      </h3>
    </div>

    <div className="card-body px-4">

      <Formik
        innerRef={formRef}
        initialValues={{
          selected_field: 0,
          structure: initialColumns,
          primary_key: collection?.schema?.primary_key,
        }}
      >
        {({ values, setFieldValue }) =>
          <Form id="collection-form">

            <table className="table table-bordered">
              <thead>
                <tr>
                  <th className="text-capitalize text-center">{l("Nombre%GA074")}</th>
                  <th className="text-capitalize text-center">{l("Tipo%GA079")}</th>
                </tr>
              </thead>
              <tbody>
                {
                  values?.structure?.map((field, idx) => field.action != "delete" && !field.internal && 
                    <ColumnField
                      key={idx}
                      idx={idx}
                      field={field}
                      values={values}
                      collections={collections}
                      isGenerated={false}
                      flow={flow}
                      showMoveButtons={false}
                      showDeleteButton={false}
                      setFieldValue={setFieldValue}
                    />
                  )
                }
              </tbody>
            </table>

            {
              error &&
              <div class="alert alert-danger" role="alert">
                {error}
              </div>
            }

            <div className="d-flex justify-content-between">
              <button
                type="button"
                class="btn btn-block btn-primary mt-3"
                disabled={isLoading}
                onClick={() => {
                  let form = document.getElementById("collection-form")
                  if (form.checkValidity())
                    onSubmit(values)
                  else
                    form.reportValidity()
                }}
              >
                {
                  isLoading &&
                  <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true" />
                }
                {
                  !isLoading && <>
                    { isUpdate ? l("Actualizar campo%CA036") : l("Crear campo%CA035") }
                  </>
                }
              </button>

            </div>

          </Form>}
      </Formik>
    </div>

  </div>
);

export default ColumnFormView;